export default __webpack_public_path__ + "static/media/mask.201b483f.png";